import { render, staticRenderFns } from "./asnav.vue?vue&type=template&id=65bcf9b7&scoped=true"
import script from "./asnav.vue?vue&type=script&lang=js"
export * from "./asnav.vue?vue&type=script&lang=js"
import style0 from "./asnav.vue?vue&type=style&index=0&id=65bcf9b7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65bcf9b7",
  null
  
)

export default component.exports